<script setup lang="ts">
import { computed } from "vue";

export interface BreadcrumbItem {
  text: string;
  to?: unknown; // Vue Router location
}

interface Props {
  backRoute?: unknown; // Vue Router location for back button
  items: BreadcrumbItem[];
}

const props = defineProps<Props>();

// The last item is the current page (bolded, no link)
const processedItems = computed(() => props.items.map((item, index) => ({
  ...item,
  isLast: index === props.items.length - 1
})));
</script>

<template>
  <v-breadcrumbs
    density="compact"
    class="pl-0 text-caption"
  >
    <!-- Breadcrumb items -->
    <template v-for="(item, index) in processedItems" :key="index">
      <v-breadcrumbs-item
        :to="item.isLast ? undefined : item.to"
        :color="item.isLast ? 'secondary' : undefined"
        :class="{ 'font-weight-bold': item.isLast }"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider v-if="!item.isLast" />
    </template>
  </v-breadcrumbs>
</template>
